import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { NoResourcesAvailable } from 'components/NoResourcesAvailable'

const NoCreatePermission: FunctionComponent = () => {
  const { t } = useTranslation()

  return (
    <NoResourcesAvailable
      title={t(
        'secrets.cloudProviderCredentialsListing.noCreatePermission.title'
      )}
      supportText={t(
        'secrets.cloudProviderCredentialsListing.noCreatePermission.content'
      )}
      data-testid="no-create-permission-cloud-provider-credential"
    />
  )
}

export default NoCreatePermission
